import * as THREE from 'three';
import type { SkillEffect } from './skill-effects.js';
import { effectParticles, shadeEffect } from './effect-surfaces.js';
import { distortionShell } from './howl-wave.js';

const DURATION = .75, STEEL = 0xd8dde0;
/** Fine vertical shivers that run down the figure: the air around the Cheat bends for a moment, like a trick of the light. */
export const SHIVER = 'sin(vWarp.y * 31.0 + uTime * 26.0) * sin(atan(vWarp.z, vWarp.x) * 5.0 + vWarp.y * 7.0 - uTime * 9.0)';

/**
 * Sneak Attack: the air around the Cheat shimmers as the blow lands, and a few cold glints of steel catch the light and fall away.
 * It belongs to the striker; the wound's gore is the blood effects' (`sneakGore`).
 */
export function sneakShimmer(height = 2, radius = .5): SkillEffect {
  const group = new THREE.Group(); group.name = 'sneak-shimmer';
  const { mesh, uniforms } = distortionShell('sneak-shimmer', SHIVER, 0xd6dde6, 3);
  mesh.position.y = height * .5; group.add(mesh);
  const glints = effectParticles(STEEL, 9, radius * .9, height * .9, 1);
  group.add(glints);
  return { group, duration: DURATION * 1000, update(p, from, _to, time = p * DURATION, ppm = 40) {
    group.position.copy(from);
    // Comes in sharp with the blow and fades over the rest of the moment.
    const strength = Math.min(1, p / .12) * (1 - p) ** 1.4;
    mesh.scale.set(radius * 1.25, height * .55, radius * 1.25);
    mesh.visible = strength > .002;
    uniforms.uIor.value = 1 + .07 * strength; uniforms.uThickness.value = .35 * strength;
    uniforms.uTime.value = time; uniforms.uRipple.value = strength;
    shadeEffect(glints, time, strength, p, ppm);
  } };
}
